import React from 'react';
import { View, StyleSheet } from 'react-native';
import BaseText from '../BaseText';
import RowView from '../RowView';
import { CommonStyles, Color, CommonProperties } from '../../styles';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';

const AirTripDetailItem = ({ label, value, ...rest }) => {
  return (
    <View {...rest}>
      <BaseText style={styles.detailItem}>{label}</BaseText>
      <BaseText>{value}</BaseText>
    </View>
  );
};

const AirTripDetail = ({ details }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('AirTripDetail');
  return (
    <RowView>
      <RowView style={CommonStyles.flex1}>
        <AirTripDetailItem
          style={CommonStyles.mr3}
          label={t(tKey('Gate'))}
          value={details.departure?.gate || '--'}
        />
        <AirTripDetailItem
          style={CommonStyles.mr3}
          label={t(tKey('Term'))}
          value={details.departure?.terminal || '--'}
        />
      </RowView>
      <RowView style={CommonStyles.flex1}>
        <AirTripDetailItem
          style={CommonStyles.mr3}
          label={t(tKey('Gate'))}
          value={details.arrival?.gate || '--'}
        />
        <AirTripDetailItem
          style={CommonStyles.mr3}
          label={t(tKey('Term'))}
          value={details.arrival?.terminal || '--'}
        />
        <AirTripDetailItem label={t(tKey('Bag'))} value={details.arrival?.bag || '--'} />
      </RowView>
    </RowView>
  );
};

const styles = StyleSheet.create({
  detailItem: {
    color: Color.grayText2,
  },
});

export default AirTripDetail;
